export class RequestToJoinGroup {
  public static readonly type = '[Browse/Groups] RequestToJoinGroup';
  constructor(public readonly groupId: string) {}
}
